<div>
  <section class="callout-section">
    <goab-callout type="success" emphasis="medium" heading="Application successfully submitted">
      <p>Application submitted: {{ application.submittedOn | date: 'longDate' }}</p>
      <p data-cy="page-title">
        <common-copy [copyText]="application.applicationNumber">
          <strong>Application number is {{ application.applicationNumber || '-' }}</strong>
        </common-copy>
      </p>
      <div class="mt-15" data-cy="successMessage">
        <p>
          Your application has been successfully sent to FSCD. We will contact you if further information is needed.
        </p>
      </div>
      <div class="mt-30">
        <a
          tabindex="0"
          role="link"
          (click)="onClickDownloadPdf()"
          (keydown.space)="onClickDownloadPdf()"
          (keydown.enter)="onClickDownloadPdf()"
          >Download PDF application</a
        >
        <p>You can view, download, and print from here.</p>
      </div>
    </goab-callout>
  </section>

  <section class="callout-section mt-15">
    <goab-callout type="information" emphasis="medium" heading="Email confirmation"
      >Please check your email for a confirmation message.</goab-callout
    >
  </section>

  <section class="button-section">
    <button
      (click)="onAddNewApplication()"
      class="action-button"
      data-cy="start-application-button"
      goab-button
      buttonType="secondary"
    >
      <span>+ Start a new application</span>
    </button>
    &nbsp;
    <button
      (click)="onViewMyApplications()"
      class="action-button"
      data-cy="view-my-application-button"
      goab-button
      buttonType="primary"
    >
      <span>View my applications</span>
    </button>
  </section>

  <!-- mobile buttons -->
  <button
    (click)="onAddNewApplication()"
    class="action-button show-mobile"
    data-cy="start-application-button-mobile"
    goab-button
    buttonType="secondary"
  >
    <span>+ Start a new application</span>
  </button>
  <button
    (click)="onViewMyApplications()"
    class="action-button show-mobile"
    data-cy="view-my-application-button-mobile"
    goab-button
    buttonType="primary"
  >
    <span>View my applications</span>
  </button>

  <!-- Start a new application -->
  <fi-start-app-modal
    [showModal]="showStartAppModal"
    (startNewApp)="onStartAppModalContinue($event)"
  ></fi-start-app-modal>
  <d3-modal-dialog
    #applicationExistsModal
    uniqueId="applicationExistsSubmitted"
    [hideUiElements]="true"
  ></d3-modal-dialog>
</div>
